import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../lib/AuthContext'

// Route-level access guard. Hiding nav items is not enough — without this, a user could reach a sensitive
// page by typing the URL. The database (RLS) is the real lock; this is the UX/defence-in-depth layer.
//   allow="admin"   → Admin only (firm Settings, User Management)
//   allow="approve" → QM or Admin (Internal Audit, Management Review, Records Retention, Assessment, Questionnaires)
//   allow="quote"   → office quote-creating roles (Sales, Ops, Doc Controller, Admin Asst, QM, Admin) — e.g. Prospects
// Anything not permitted is bounced to the dashboard.
export default function RequireRole({ allow, children }) {
  const { isAdmin, canApprove, canCreateQuote, loading } = useAuth()
  if (loading) return <div style={{ color: '#888', padding: 24 }}>Loading…</div>
  const ok = allow === 'admin' ? isAdmin : allow === 'approve' ? canApprove : allow === 'quote' ? canCreateQuote : true
  if (!ok) return <Navigate to="/" replace />
  return children
}
